export const BRAND_SOURCE_PDF_MIME = "application/pdf";
export const MAX_BRAND_SOURCE_PDF_MB = 20;

const MAX_BRAND_SOURCE_PDF_BYTES = MAX_BRAND_SOURCE_PDF_MB * 1024 * 1024;

export const BRAND_SOURCE_PDF_ERROR_FORMAT = "format";
export const BRAND_SOURCE_PDF_ERROR_SIZE = "size";

/**
 * Returns the reason a file cannot be used as the optional brand brief PDF,
 * or "" when it is valid. Mirrors the limits enforced by the API.
 */
export const getBrandSourcePdfError = ({ file } = {}) => {
  if (
    !String(file?.name || "")
      .toLowerCase()
      .endsWith(".pdf")
  ) {
    return BRAND_SOURCE_PDF_ERROR_FORMAT;
  }
  if ((file?.size || 0) > MAX_BRAND_SOURCE_PDF_BYTES) {
    return BRAND_SOURCE_PDF_ERROR_SIZE;
  }
  return "";
};
